import Swal from 'sweetalert2'

const dialog = {
    info : function(message) {
        Swal.fire({
            icon: 'info',
            title: 'Information',
            text: message,
        });
    },
    error : function(message) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message,
        });
    },
    warn : function(message, callback) {
        Swal.fire({
            icon: 'warning',
            title: 'Warning',
            text: message,
        }).then(function() {
            if (callback) callback();
        });
    },
    show : function (detail) {
        Swal.fire({
            html: '<b>หมายเหตุ : </b>' + detail
        });
    }
}


export default dialog;